import { Link } from "react-router-dom";
import AIInterviewBadge from "./AIInterviewBadge";
import { WarningChips } from "./aiShared";
import { AI_MODE, AI_MODE_LABELS, AI_STATUS, isFinalAIStatus } from "../../utils/aiInterviewApi";

export const liveDashboardPath = (interviewId) => `/interviews/${encodeURIComponent(interviewId)}/ai-live`;

// AI status for an interview row. `summary` comes from aiSummaryOf(); mode, round and warnings
// are only known once the AI session has been fetched.
export default function AIInterviewStatusCell({ interviewId, summary, onOpen }) {
  if (!summary) return null;
  const meta = [AI_MODE_LABELS[summary.mode], summary.roundName].filter(Boolean).join(" · ");
  const showLiveLink =
    summary.enabled && summary.mode === AI_MODE.PANELIST_WITH_AI && !isFinalAIStatus(summary.status);

  return (
    <div className="flex flex-col items-start gap-1 w-full max-w-[300px]">
      <AIInterviewBadge summary={summary} onClick={onOpen} />
      {meta && <span className="text-xs text-gray-600">{meta}</span>}
      {summary.status === AI_STATUS.FAILED && summary.failureMessage && (
        <span className="text-xs text-red-700 max-w-[240px]">{summary.failureMessage}</span>
      )}
      <WarningChips warnings={summary.warnings} />
      {showLiveLink && (
        <Link
          to={liveDashboardPath(interviewId)}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-medium text-blue-700 underline"
        >
          Live dashboard
        </Link>
      )}
    </div>
  );
}
